export const shuttleData = {
  lastUpdated: "2026-08-20",
  semesterStart: "2026-03-04",
  source: "수원대학교 2026학년도 2학기 학생 통학버스 공식 안내문",
  crawlSuccess: false,
  confidence: "manual_from_official",
  routes: [
    {
      routeId: "songnae_to_school",
      routeName: "송내역 → 학교",
      fare: "모바일 승차권 2,300원",
      stops: [
        {
          stopName: "송내역",
          location: "고려한증막 앞 · 1번 출구에서 송내지하차도 방향 150m 직진 · 4구역(노면표시 4번)",
          times: ["07:50", "09:00", "10:20"],
          buses: [2, 2, 1]
        }
      ],
      // 기존 실사용 시간표는 보존하고, 2학기 추가 운행만 별도 메타로 관리한다.
      additionalSchedules: [
        {
          id: "songnae_0745_student_hall",
          time: "07:45",
          destinationLabel: "학생회관 사거리",
          routeSummary: "송내역 → 학생회관 사거리",
          tripVariant: "student_hall"
        }
      ]
    },
    {
      routeId: "school_to_songnae",
      routeName: "학교 → 송내역",
      fare: "모바일 승차권 2,300원",
      stops: [
        {
          stopName: "송내역 하교",
          times: ["15:50", "16:50", "17:50"],
          buses: [1, 1, 1]
        }
      ]
    },
    {
      routeId: "gosaek_to_school",
      routeName: "고색역 → 학교",
      fare: "무료 운행 (전세버스)",
      stops: [
        {
          stopName: "고색역",
          location: "3번 출구 · 새마을금고 앞",
          times: ["08:40", "08:45", "08:50", "10:00"],
          buses: [1, 1, 3, 1]
        }
      ]
    },
    {
      routeId: "gangnam_to_school",
      routeName: "강남역 → 학교",
      fare: "모바일 승차권 2,000원",
      stops: [
        {
          stopName: "강남역 7번 출구 산업은행 앞",
          times: ["07:50"],
          buses: [1]
        }
      ]
    },
    {
      routeId: "sadang_to_school",
      routeName: "사당역 → 학교",
      fare: "모바일 승차권 2,000원",
      stops: [
        {
          stopName: "사당역 홈플러스 버스 승차장 앞",
          location: "4호선 4번 출구에서 홈플러스 방향 300m · 2호선 5번 출구에서 홈플러스 방향 400m",
          times: ["08:00"],
          buses: [1]
        }
      ]
    },
    {
      routeId: "byeongjeom_to_school",
      routeName: "병점역 → 학교",
      fare: "무료 운행 (전세버스)",
      stops: [
        {
          stopName: "병점역 후문",
          location: "2번·3번 출구 / 버스정류장 앞",
          times: ["08:30", "08:40", "08:50", "10:00", "11:00"],
          buses: [1, 1, 3, 1, 1]
        }
      ]
    },
    {
      routeId: "school_to_byeongjeom",
      routeName: "학교 → 병점역",
      fare: "무료 운행",
      stops: [
        {
          stopName: "병점역 하교 셔틀 승차장",
          times: ["16:40"],
          buses: [1]
        }
      ]
    },
    {
      routeId: "campus_loop",
      routeName: "교내 셔틀버스",
      fare: "무료 운행",
      stops: [
        {
          stopName: "교내 순환",
          location: "인문대 앞 → 학생회관 사거리 → ICT융합대학 → 음악대학 → 제1공학관 → 후문(제4공학관) → 미술대학(조형관) → 인문대 앞",
          times: ["09:10", "09:20", "10:10", "10:20", "11:10", "11:20", "12:10", "13:20", "14:20", "15:20"],
          busTypes: ["charter", "charter", "charter", "charter", "schoolBus", "schoolBus", "schoolBus", "schoolBus", "schoolBus", "schoolBus"],
          charterStations: ["병점", "고색", "고색", "고색", null, null, null, null, null, null]
        }
      ]
    }
  ],
  notices: [
    "2026년 3월 4일(수)부터 운행 시작, 학기 중 월~금요일 운행 (방학·공휴일 제외).",
    "이용 학생 수에 따라 증차·감차되며, 승차율 저조 시(15명 이하) 운행 잠정 정지될 수 있습니다.",
    "모바일 탑승시스템을 이용해야 하며, 현금 승차는 불가합니다.",
    "도로 사정에 따라 차량 운행이 지연될 수 있으며, 입석은 금지됩니다.",
    "만석(45인) 시 탑승이 제한되오니 여유 있게 이동하세요.",
    "운행 시간 및 노선은 운영 방침에 따라 변경될 수 있습니다."
  ]
}
